// src/data/translations.js
// Spanish translations for all UI strings and content.
// English is the default. Spanish is loaded when lang === 'es'.
// Usage: import { t } from '@data/translations'; t('sos_button', lang)

// ── UI Strings ────────────────────────────────────────────────────
export const UI = {
  // Navigation
  dashboard:          { en: 'DASHBOARD',    es: 'TABLERO' },
  resources:          { en: 'RESOURCES',    es: 'RECURSOS' },
  command:            { en: 'COMMAND',      es: 'COMANDO' },
  more:               { en: 'MORE',         es: 'MÁS' },

  // Feed
  feed:               { en: 'Feed',         es: 'Noticias' },
  news:               { en: 'News',         es: 'Noticias' },
  missing:            { en: 'Missing',      es: 'Desaparecidos' },
  prep:               { en: 'Prep',         es: 'Preparación' },
  family:             { en: 'Family',       es: 'Familia' },

  // SOS
  sos_button:         { en: 'NEED HELP / SOS', es: 'NECESITO AYUDA / SOS' },
  sos_title:          { en: 'Need Help?',    es: 'Necesita Ayuda?' },
  sos_subtitle:       { en: 'Select what you need, then add details and your location.', es: 'Seleccione lo que necesita, luego agregue detalles y su ubicacion.' },
  call_911:           { en: 'CALL 911 NOW', es: 'LLAME AL 911 AHORA' },
  broadcast:          { en: 'Broadcast to Neighborhood', es: 'Transmitir al Vecindario' },
  also_call_911:      { en: 'Also call 911 directly', es: 'Tambien llame al 911 directamente' },

  // SOS options
  sos_medical:        { en: 'Medical Emergency', es: 'Emergencia Medica' },
  sos_trapped:        { en: 'Trapped / Rescue',  es: 'Atrapado / Rescate' },
  sos_food:           { en: 'Need Food & Water', es: 'Necesito Comida y Agua' },
  sos_check:          { en: 'Welfare Check',     es: 'Verificación de Bienestar' },
  sos_power:          { en: 'Generator Help',    es: 'Ayuda con Generador' },

  // Location
  use_gps:            { en: 'Use GPS',       es: 'Usar GPS' },
  enter_address:      { en: 'Enter Address', es: 'Ingresar Direccion' },
  gps_success:        { en: 'GPS: Got it',   es: 'GPS: Obtenido' },
  gps_loading:        { en: 'Getting GPS...', es: 'Obteniendo GPS...' },
  address_placeholder:{ en: 'Street address or cross streets', es: 'Dirección o calles cercanas' },
  unit_placeholder:   { en: 'Apt / Unit / Floor (optional)', es: 'Apto / Unidad / Piso (opcional)' },

  // Status
  online:             { en: 'ONLINE',        es: 'EN LINEA' },
  offline:            { en: 'OFFLINE',       es: 'SIN CONEXION' },

  // Alert bar
  active_alert:       { en: 'Active Alert — tap for details', es: 'Alerta Activa — toque para detalles' },
  flash_flood_warning:{ en: 'Flash flood warning active for your area', es: 'Advertencia de inundación activa en su área' },

  // Sections
  describe_situation: { en: 'Describe your situation', es: 'Describa su situacion' },
  your_location:      { en: 'Your Location', es: 'Su Ubicacion' },
  photo_video:        { en: 'Photo or Video (optional)', es: 'Foto o Video (opcional)' },
  camera:             { en: 'Camera',        es: 'Camara' },
  gallery:            { en: 'Gallery',       es: 'Galeria' },
  video:              { en: 'Video',         es: 'Video' },

  // Gas
  gas_title:          { en: 'Gas Stations',  es: 'Gasolineras' },
  open:               { en: 'Open',          es: 'Abierto' },
  busy:               { en: 'Busy',          es: 'Ocupado' },
  closed:             { en: 'Closed',        es: 'Cerrado' },
  no_wait:            { en: 'No wait',       es: 'Sin espera' },

  // Map
  map:                { en: 'Map',           es: 'Mapa' },
  evacuate:           { en: 'Evacuate',      es: 'Evacuar' },
  traffic:            { en: 'Traffic',       es: 'Trafico' },
  situation:          { en: 'Situation',     es: 'Situación' },
  supply:             { en: 'Supply',        es: 'Suministros' },
  storm:              { en: 'Storm',         es: 'Tormenta' },
  community:          { en: 'Community',     es: 'Comunidad' },

  // First Aid
  first_aid:          { en: 'First Aid',     es: 'Primeros Auxilios' },
  first_aid_subtitle: { en: 'Step-by-step emergency guidance', es: 'Guia de emergencia paso a paso' },
  call_first:         { en: 'CALL 911 FIRST', es: 'LLAME AL 911 PRIMERO' },
  step:               { en: 'Step',          es: 'Paso' },

  // Alerts page
  alerts_title:       { en: 'NWS Alerts',    es: 'Alertas NWS' },
  my_zones:           { en: '📍 My Zones',   es: '📍 Mis Zonas' },
  all_louisiana:      { en: '🌊 All Louisiana', es: '🌊 Toda Louisiana' },
  no_active_alerts:   { en: 'No active alerts', es: 'Sin alertas activas' },
  no_alerts_desc:     { en: 'No NWS weather alerts are currently active. Stay prepared.', es: 'No hay alertas meteorologicas activas en este momento. Mantengase preparado.' },
  could_not_load:     { en: 'Could not load alerts', es: 'No se pudieron cargar las alertas' },
  retry:              { en: 'Retry',          es: 'Reintentar' },
  full_nws_alert:     { en: 'Full NWS Alert', es: 'Alerta NWS Completa' },

  // Shelters page
  shelters_title:     { en: 'Emergency Shelters', es: 'Refugios de Emergencia' },
  shelter_all:        { en: 'All',           es: 'Todos' },
  shelter_pets:       { en: 'Pets OK',       es: 'Mascotas OK' },
  shelter_special:    { en: 'Special Needs', es: 'Necesidades Especiales' },
  shelter_medical:    { en: 'Medical',       es: 'Medico' },
  shelter_open:       { en: 'Open',          es: 'Abierto' },
  shelter_full:       { en: 'At Capacity',   es: 'Lleno' },
  shelter_closed:     { en: 'Closed',        es: 'Cerrado' },
  shelter_unknown:    { en: 'Unknown',       es: 'Desconocido' },
  get_directions:     { en: 'Get Directions', es: 'Obtener Direcciones' },
  call_shelter:       { en: 'Call Shelter',  es: 'Llamar al Refugio' },
  nearest_shelters:   { en: 'Nearest to your zone', es: 'Más cercano a su zona' },
  other_shelters:     { en: 'Other Shelters', es: 'Otros Refugios' },

  // Resources page
  resources_title:    { en: 'Resources',     es: 'Recursos' },
  res_gas:            { en: 'Gas',           es: 'Gasolina' },
  res_food:           { en: 'Food',          es: 'Comida' },
  res_pharmacy:       { en: 'Pharmacy',      es: 'Farmacia' },
  res_charging:       { en: 'Charging',      es: 'Carga' },
  res_ice:            { en: 'Ice',           es: 'Hielo' },
  res_water:          { en: 'Water',         es: 'Agua' },
  res_open:           { en: 'Open',          es: 'Abierto' },
  res_limited:        { en: 'Limited',       es: 'Limitado' },
  res_closed:         { en: 'Closed',        es: 'Cerrado' },
  res_unknown:        { en: 'Unknown',       es: 'Desconocido' },

  // Feed page
  feed_title:         { en: 'Feed',          es: 'Noticias' },
  feed_placeholder:   { en: "What's happening on your street?", es: '¿Qué pasa en su calle?' },
  feed_post:          { en: 'Post to Feed',  es: 'Publicar en Noticias' },
  feed_posting:       { en: 'Posting…',      es: 'Publicando…' },
  show_all_zones:     { en: '🌍 Show all zones', es: '🌍 Ver todas las zonas' },
  my_zones_only:      { en: '← My zones only', es: '← Solo mis zonas' },
  need_help_sos:      { en: 'NEED HELP / SOS', es: 'NECESITO AYUDA / SOS' },
  show_all:           { en: 'All',           es: 'Todo' },
  filter_critical:    { en: 'Critical',      es: 'Critico' },
  filter_flood:       { en: 'Flood',         es: 'Inundacion' },
  filter_roads:       { en: 'Roads',         es: 'Calles' },
  filter_gas:         { en: 'Gas',           es: 'Gasolina' },
  no_reports:         { en: "No active incidents in your selected zones. That's good news.", es: 'No hay incidentes activos en sus zonas. Eso es una buena noticia.' },
  warning:            { en: 'WARNING',       es: 'ADVERTENCIA' },
  back:               { en: 'Back',          es: 'Atras' },

  // Emergency Plan
  emergency_plan:     { en: 'Family Emergency Plan', es: 'Plan de Emergencia Familiar' },
  plan_subtitle:      { en: 'Build your family plan step by step', es: 'Cree su plan familiar paso a paso' },

  // Toolkit
  toolkit:            { en: 'Emergency Toolkit', es: 'Kit de Emergencia' },
  flashlight:         { en: 'Flashlight',     es: 'Linterna' },
  strobe:             { en: 'Strobe Light',   es: 'Luz Estroboscopica' },
  alarm:              { en: 'Audible Alarm',  es: 'Alarma Audible' },
  tap_to_activate:    { en: 'Tap to activate', es: 'Toque para activar' },

  // Hospitals
  hospitals:          { en: 'Nearby Hospitals', es: 'Hospitales Cercanos' },
  er:                 { en: 'Emergency Room', es: 'Sala de Emergencias' },
  open_24:            { en: 'Open 24/7',      es: 'Abierto 24/7' },
  get_directions:     { en: 'Directions',     es: 'Direcciones' },
  call:               { en: 'Call',           es: 'Llamar' },

  // General
  save:               { en: 'Save',           es: 'Guardar' },
  cancel:             { en: 'Cancel',         es: 'Cancelar' },
  close:              { en: 'Close',          es: 'Cerrar' },
  confirm:            { en: 'Confirm',        es: 'Confirmar' },
  report:             { en: 'Report',         es: 'Reportar' },
  share:              { en: 'Share',          es: 'Compartir' },
  loading:            { en: 'Loading...',     es: 'Cargando...' },
  retry:              { en: 'Retry',          es: 'Reintentar' },
  settings:           { en: 'Settings',       es: 'Configuración' },
  language:           { en: 'Language',       es: 'Idioma' },
  english:            { en: 'English',        es: 'Inglés' },
  spanish:            { en: 'Spanish',        es: 'Español' },
  // Situation tab (new)
  situation_overview:   { en: 'Situation Overview',      es: 'Resumen de Situación' },
  current_situation:    { en: 'Current Situation',        es: 'Situación Actual' },
  next_best_action:     { en: 'Next Best Action',         es: 'Siguiente Mejor Acción' },
  ai_predictions:       { en: 'AI Predictions',           es: 'Predicciones IA' },
  roads:                { en: 'Roads',                    es: 'Carreteras' },
  utilities:            { en: 'Utilities',                es: 'Servicios' },
  weather:              { en: 'Weather',                  es: 'Clima' },
  developing:           { en: 'developing',               es: 'desarrollando' },
  updated_just_now:     { en: 'Updated just now',         es: 'Actualizado ahora mismo' },
  moderate:             { en: 'Moderate',                 es: 'Moderado' },
  normal:               { en: 'Normal',                   es: 'Normal' },
  active_alert_label:   { en: 'Active Alert',             es: 'Alerta Activa' },

  // Find Help (new)
  find_help:            { en: 'Find Help',                es: 'Encontrar Ayuda' },
  what_do_you_need:     { en: 'What do you need?',        es: '¿Qué necesita?' },
  fuel:                 { en: 'Fuel',                     es: 'Combustible' },
  food_water:           { en: 'Food & Water',             es: 'Comida y Agua' },
  shelter:              { en: 'Shelter',                  es: 'Refugio' },
  pharmacy:             { en: 'Pharmacy',                 es: 'Farmacia' },
  charging:             { en: 'Charging',                 es: 'Carga' },
  navigate:             { en: 'Navigate',                 es: 'Navegar' },
  recommended:          { en: 'Recommended Right Now',    es: 'Recomendado Ahora' },
  check_status:         { en: 'Check status',             es: 'Ver estado' },
  view_shelters:        { en: 'View shelters',            es: 'Ver refugios' },
  nearby:               { en: 'nearby',                   es: 'cercano' },
  locations_nearby:     { en: 'Locations nearby',         es: 'Ubicaciones cercanas' },
  resource_status:      { en: "Today's Resource Status",  es: 'Estado de Recursos Hoy' },

  // My Neighborhood (new)
  my_neighborhood:      { en: 'My Neighborhood',          es: 'Mi Vecindario' },
  can_i_drive:          { en: 'Can I drive?',             es: '¿Puedo manejar?' },
  where_can_i_go:       { en: 'Where can I go?',          es: '¿A donde puedo ir?' },
  need_medical:         { en: 'Need medical care?',       es: '¿Necesita atencion medica?' },
  todays_priority:      { en: "Today's Priority",         es: 'Prioridad de Hoy' },
  operational_score:    { en: 'Operational Score',        es: 'Puntuación Operacional' },
  ai_insights:          { en: 'AI Insights',              es: 'Perspectivas IA' },
  family_monitor:       { en: 'Family Monitor',           es: 'Monitor Familiar' },
  is_improving:         { en: 'Is the situation improving?', es: '¿Mejora la situación?' },


  // Splash page
  select_parish:        { en: 'Select your parish',       es: 'Seleccione su parroquia' },
  zones_count:          { en: 'zones',                    es: 'zonas' },
  enter_app:            { en: 'Enter Eye on Storm',        es: 'Entrar a Eye on Storm' },
  free_offline:         { en: 'Free · Works offline · No account required', es: 'Gratis · Funciona sin internet · Sin cuenta requerida' },
  back_arrow:           { en: '← Back',                   es: '← Atrás' },

  // Heat action guidance
  stay_in_ac:           { en: 'Stay in AC',               es: 'Permanezca en AC' },
  drink_water:          { en: 'Drink water frequently',   es: 'Beba agua frecuentemente' },
  check_elderly:        { en: 'Check on elderly',         es: 'Visite a personas mayores' },
  avoid_outdoor:        { en: 'Avoid prolonged outdoor activity', es: 'Evite actividad prolongada al aire libre' },
  stay_hydrated:        { en: 'Stay hydrated',            es: 'Manténgase hidratado' },
  peak_hours:           { en: 'Stay indoors during peak hours (10am–4pm)', es: 'Permanezca adentro en horas pico (10am–4pm)' },
  check_neighbors:      { en: 'Check on elderly family members and neighbors', es: 'Visite a familiares mayores y vecinos' },

  // Hurricane action guidance
  evacuate_now:         { en: 'Evacuate if ordered',      es: 'Evacúe si se le ordena' },
  secure_home:          { en: 'Secure your home',         es: 'Asegure su hogar' },
  charge_devices:       { en: 'Charge all devices now',   es: 'Cargue todos los dispositivos ahora' },
  avoid_roads:          { en: 'Travel only if under evacuation order', es: 'Viaje solo si está bajo orden de evacuación' },

  // Flood action guidance
  move_to_high_ground:  { en: 'Move to higher ground',   es: 'Muévase a terreno elevado' },
  avoid_floodwater:     { en: 'Never walk in floodwater', es: 'Nunca camine en agua de inundación' },

  // Cooling centers
  cooling_centers:      { en: 'Cooling Centers',          es: 'Centros de Enfriamiento' },
  cooling_guidance:     { en: 'Where to find cooling during extreme heat:', es: 'Dónde encontrar enfriamiento durante calor extremo:' },
  cooling_libraries:    { en: '🏛 Public libraries — free AC, open to all', es: '🏛 Bibliotecas públicas — AC gratis, abiertas a todos' },
  cooling_centers_rec:  { en: '🏫 Community centers and recreation facilities', es: '🏫 Centros comunitarios e instalaciones recreativas' },
  cooling_malls:        { en: '🏪 Malls, grocery stores, and pharmacies', es: '🏪 Centros comerciales, supermercados y farmacias' },
  cooling_churches:     { en: '⛪ Churches and houses of worship', es: '⛪ Iglesias y centros religiosos' },
  cooling_call_211:     { en: '📞 Call 211 for verified cooling center locations near you', es: '📞 Llame al 211 para ubicaciones verificadas de centros de enfriamiento' },
  cooling_add_report:   { en: 'Know of an open cooling center? Tap "+ Add Report" to share with your community.', es: '¿Conoce un centro de enfriamiento abierto? Toque "+ Agregar Reporte" para compartir.' },

  // 211 card
  united_way_title:     { en: '211 · United Way Louisiana', es: '211 · United Way Louisiana' },
  united_way_sub:       { en: 'Community Resource Referral', es: 'Referencia de Recursos Comunitarios' },
  united_way_desc:      { en: 'Free helpline connecting Louisiana residents to food, shelter, utilities, health services, and disaster assistance — 24/7 in English and Spanish.', es: 'Línea de ayuda gratuita que conecta a residentes de Louisiana con comida, refugio, servicios públicos, salud y asistencia en desastres — 24/7 en inglés y español.' },
  call_211:             { en: '📞 Call 211',                es: '📞 Llamar al 211' },

  // Resource status
  fuel_status:          { en: 'Fuel',                     es: 'Combustible' },
  medical_status:       { en: 'Medical',                  es: 'Médico' },
  shelters_status:      { en: 'Shelters',                 es: 'Refugios' },
  food_status:          { en: 'Food',                     es: 'Comida' },
  charging_status:      { en: 'Charging',                 es: 'Carga' },
  pharmacy_status:      { en: 'Pharmacy',                 es: 'Farmacia' },
  view_designated:      { en: 'View designated',          es: 'Ver designados' },
  check_reports:        { en: 'Check reports',            es: 'Ver reportes' },
  available:            { en: 'Available',                es: 'Disponible' },
  unknown:              { en: 'Unknown',                  es: 'Desconocido' },
  high:                 { en: 'High',                     es: 'Alto' },
  med:                  { en: 'Med',                      es: 'Med' },
  low:                  { en: 'Low',                      es: 'Bajo' },

  // Situation summary
  situation_stable:     { en: 'Most services remain operational. Monitor official guidance.', es: 'La mayoría de los servicios continúan operacionales. Monitoree las guías oficiales.' },
  no_shelters_open:     { en: 'No shelters are currently open nearby.', es: 'No hay refugios abiertos cerca actualmente.' },
  road_closures_active: { en: 'road closures are active.', es: 'cierres de carretera activos.' },
  no_power_outages:     { en: 'No known power outages reported.', es: 'No hay cortes de energía reportados.' },
  monitor_until:        { en: 'Monitor official guidance until', es: 'Monitoree las guías oficiales hasta' },

  // Offline banner
  offline_banner:       { en: '⚠ Device offline — showing last known data · recheck when connected', es: '⚠ Dispositivo sin conexión — mostrando últimos datos · verifique cuando esté conectado' },

  // Situation overview labels
  severe_alert:         { en: '🟠 Severe Alert',           es: '🟠 Alerta Grave' },
  extreme_alert:        { en: '🔴 Extreme Alert',          es: '🔴 Alerta Extrema' },
  moderate_alert:       { en: '🟡 Active Alert',           es: '🟡 Alerta Activa' },
  no_known_issues:      { en: '⚪ No known issues',        es: '⚪ Sin problemas conocidos' },
  developing_signals:   { en: 'Developing Signals',        es: 'Señales en Desarrollo' },
  // My Locations (new)
  my_locations:         { en: 'My Locations',             es: 'Mis Ubicaciones' },
  current_zone:         { en: 'Current Zone',             es: 'Zona Actual' },
  saved_zones:          { en: 'Saved Zones',              es: 'Zonas Guardadas' },
  switch_zone:          { en: 'Switch Active Zone',       es: 'Cambiar Zona Activa' },
  detect_location:      { en: 'Detect Location',          es: 'Detectar Ubicacion' },
  search_zone:          { en: 'Search Zone or Address',   es: 'Buscar Zona o Direccion' },
  follow_places:        { en: 'Follow Places',            es: 'Seguir Lugares' },
  auto_detect:          { en: 'Auto-detect Location',     es: 'Detección Automática' },
  add_zone:             { en: 'Add Zone',                 es: 'Agregar Zona' },
  offline_backup:       { en: 'Offline Backup',           es: 'Respaldo Sin Conexion' },

  // Boil water
  boil_water_advisory:  { en: 'Boil Water Advisory',     es: 'Aviso de Hervir Agua' },
  boil_water_inst:      { en: 'Boil tap water for at least 1 minute before drinking.', es: 'Hierva el agua del grifo por al menos 1 minuto antes de beber.' },
  call_swbno:           { en: 'Call SWBNO',               es: 'Llamar SWBNO' },

  // Emergency shelters (new)
  designated_shelter:   { en: 'Designated Shelter',      es: 'Refugio Designado' },
  nearest_shelter:      { en: 'Nearest Shelter',         es: 'Refugio Más Cercano' },
  your_parish:          { en: 'Your Parish',             es: 'Su Parroquia' },
  capacity:             { en: 'capacity',                es: 'capacidad' },
  pets_ok:              { en: 'Pets OK',                 es: 'Mascotas OK' },
  ada_accessible:       { en: 'ADA Accessible',          es: 'Accesible ADA' },

};

// ── Translation helper ────────────────────────────────────────────
export function t(key, lang = 'en') {
  const entry = UI[key];
  if (!entry) return key;
  return entry[lang] ?? entry.en ?? key;
}

// ── First Aid translations ────────────────────────────────────────
export const FIRST_AID_ES = {
  cpr: {
    title: 'RCP (Adultos)',
    summary: 'Para alguien que no responde y no respira normalmente.',
    steps: [
      { title: 'Llame al 911',         body: 'Llame al 911 inmediatamente o pida a alguien que llame mientras comienza la RCP.' },
      { title: 'Posicion de manos',    body: 'Coloque el talon de su mano en el centro del pecho. Ponga la otra mano encima y entrelace los dedos.' },
      { title: 'Comprima fuerte',      body: 'Comprima al menos 5 centimetros. De 30 compresiones a 100-120 por minuto. Deje que el pecho suba completamente.' },
      { title: 'De 2 respiraciones',   body: 'Incline la cabeza, levante el menton. Tape la nariz. De 2 respiraciones de 1 segundo. Vea si el pecho sube.' },
      { title: 'Repita',               body: 'Continue el ciclo de 30 compresiones y 2 respiraciones hasta que la persona respire, llegue el EMS, o no pueda continuar.' },
      { title: 'Use un DEA',           body: 'Si hay un desfibrilador, enciendalo y siga las instrucciones de voz. Reanude la RCP inmediatamente despues de cada descarga.' },
    ],
  },
  stroke: {
    title: 'Derrame Cerebral - Prueba RAPS',
    summary: 'Use el metodo RAPS para identificar un derrame y actue inmediatamente.',
    steps: [
      { title: 'R — Rostro caido',     body: 'Pida a la persona que sonria. Hay un lado de la cara caido o adormecido?' },
      { title: 'A — Brazos',           body: 'Pida que levante ambos brazos. Cae uno hacia abajo? La debilidad en los brazos es una senal.' },
      { title: 'P — Palabras',         body: 'Pida que repita una frase simple. El habla es confusa o la persona no puede hablar?' },
      { title: 'S — Solicite ayuda',   body: 'Si hay CUALQUIER senal, llame al 911 inmediatamente. Anote la hora exacta en que comenzaron los sintomas.' },
      { title: 'Mientras espera',      body: 'Mantenga a la persona tranquila y acostada. No le de comida, agua ni medicamentos.' },
    ],
  },
  // Additional Spanish translations follow the same pattern for each first aid item
};

// ── Emergency Plan translations ───────────────────────────────────
export const EMERGENCY_PLAN_ES = {
  steps: [
    { title: 'Punto de encuentro local',     body: 'Elija un lugar cerca de su casa donde todos se reunan si no pueden entrar o hay una emergencia.' },
    { title: 'Punto de encuentro regional', body: 'Elija un lugar fuera del vecindario en caso de evacuacion.' },
    { title: 'Contacto fuera del estado',   body: 'Elija a alguien fuera de Louisiana que todos puedan contactar para verificar el estado.' },
    { title: 'Plan de comunicacion',        body: 'Decida como se comunicaran: mensajes de texto, redes sociales, o mensajes de voz.' },
    { title: 'Rutas de evacuacion',         body: 'Practiquen al menos 2 rutas de salida desde su casa y desde su vecindario.' },
    { title: 'Kit de emergencia',           body: 'Preparen un kit con 72 horas de agua, comida, medicamentos, documentos y suministros de emergencia.' },
    { title: 'Necesidades especiales',      body: 'Identifiquen y planifiquen para mascotas, personas mayores, personas con discapacidades y bebe.' },
    { title: 'Practiquen el plan',          body: 'Revisen y practiquen el plan dos veces al ano. Actualicen los numeros de contacto.' },
  ],
};
